export function assign<T extends object, K extends keyof T>(
    obj: T, key: K, val: T[K]
) {
    obj[key] = val; // okay
}

export function buildProoflistFilename(header: any, dialogAttempt?: string, fallbackSubmissionType?: number): string {
    const providerRaw = header["-ProviderCode"] || header["ProviderCode"] || "";
    const periodRaw = header["-FileReferenceDate"] || header["FileReferenceDate"] || header["-ReportReferencePeriod"] || header["ReportReferencePeriod"] || header["-CutoffDate"] || header["CutoffDate"] || "";
    const providerDigits = ("" + providerRaw).replace(/\D/g, "");
    const provider = providerDigits ? providerDigits.padStart(9, '0') : '';
    let period = ("" + periodRaw).replace(/\D/g, "");
    if (period.length >= 8) period = period.slice(0, 8);
    if (!provider || !period) return 'prooflist.xlsx';

    let submission = ("" + (dialogAttempt ?? "")).replace(/\D/g, "");
    if (submission) {
        let submissionNum = parseInt(submission, 10);
        if (!isFinite(submissionNum) || submissionNum <= 0) submissionNum = 1;
        submission = String(submissionNum);
    } else if (typeof fallbackSubmissionType === 'number' && fallbackSubmissionType >= 0) {
        let submissionNum = parseInt(String(fallbackSubmissionType), 10);
        if (!isFinite(submissionNum) || submissionNum <= 0) submissionNum = 1;
        submission = String(submissionNum);
    } else {
        const submissionRaw = header["-SubmissionAttempt"] || header["SubmissionAttempt"] || header["-SubmissionSequence"] || header["SubmissionSequence"] || "1";
        submission = ("" + submissionRaw).replace(/\D/g, "");
        let submissionNum = parseInt(submission || "", 10);
        if (!isFinite(submissionNum) || submissionNum <= 0) submissionNum = 1;
        submission = String(submissionNum);
    }

    return `${provider}_CNPR_${period}_${submission}.xlsx`;
}
